import { Link } from "react-router-dom";
import { weekDays, animeList, todayDay } from "@/mocks/anime";

export default function CalendarPreview() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium text-accent-600">追番日历</span>
            <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
              一周更新一目了然
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              按星期快速定位正在更新的作品，今天有更新的日子会高亮显示。
            </p>
          </div>
          <Link
            to="/calendar"
            className="whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700"
          >
            打开完整日历 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7">
          {weekDays.map((day) => {
            const items = animeList.filter((a) => a.day === day);
            const isToday = day === todayDay;
            return (
              <Link
                key={day}
                to={`/calendar#${day}`}
                className={`flex flex-col rounded-lg border p-4 transition-colors ${
                  isToday
                    ? "border-accent-300 bg-accent-100"
                    : "border-background-200 bg-background-50 hover:border-accent-200"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`text-sm font-bold ${isToday ? "text-accent-800" : "text-foreground-950"}`}
                  >
                    {day}
                  </span>
                  {isToday && (
                    <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
                      今天
                    </span>
                  )}
                </div>
                <span
                  className={`mt-2 font-heading text-2xl ${isToday ? "text-accent-700" : "text-primary-500"}`}
                >
                  {items.length || "0"}
                </span>
                <span className="text-xs text-foreground-600">部更新</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}